import {Pipe, PipeTransform} from '@angular/core';

/**
 * Dies ist eine Angular-Pipe mit dem Namen "skuFormatter", die eine SKU-Nummer formatiert, indem er sie in ein Format umwandelt, das aus drei durch Bindestriche getrennten Abschnitten besteht.
 */

@Pipe({
  name: 'skuFormatter'
})
export class SkuFormatterPipe implements PipeTransform {

  transform(sku: number): string {
    const originalSku = sku.toString();
    return originalSku.substring(0, 2) + '-' + originalSku.substring(2, 6) + '-' + originalSku.substring(6, 10);
  }
}
